import api from './api';

export const updateMyTheme       = (mode, accent) => api.put('/api/users/theme', { mode, accent });
export const updateProviderTheme = (mode, accent) => api.put('/api/providers/theme', { mode, accent });
